import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Self } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { faSend } from '@fortawesome/pro-regular-svg-icons';
import { ReplaySubject, Subscription } from 'rxjs';

@Component({
  selector: 'empathy-comment-input',
  templateUrl: './comment-input.component.html',
  styleUrls: ['./comment-input.component.scss']
})
export class CommentInputComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() icon: IconDefinition;

  @Output() clicked = new EventEmitter<string>();

  onChange: (value: string) => void;
  onTouched: () => void;

  faSend = faSend;

  control: FormControl;
  currentValue: string;

  private input$ = new ReplaySubject(1);
  private subscriptions: Subscription[] = [];

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  ngOnInit(): void {
    this.control = this.ngControl.control as FormControl;

    this.subscriptions.push(
      this.input$.subscribe((input: string) => {
        this.onTouched();
        this.onChange(input);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(input: string): void {
    this.currentValue = input ?? '';
  }

  setValue($event: any): void {
    this.currentValue = $event.target.value;
    this.input$.next($event.target.value);
  }
}
